import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { IRootNodeFormState } from "source/app/presentation/MainPanel/Workflows/RootNodeName/Helpers/IRootNodeFormState";

export function GetMergedFormState(rootNode: IWorkflowNode) {
    return {
        showEditControls: false,
        newName: rootNode.name,
        newMaxChildren: rootNode.maxchildren!,
        newSortOrder: rootNode.sortorder ? rootNode.sortorder : [],
        newOptions: rootNode.options,
        rootNode: rootNode
    } as IRootNodeFormState;
}
